/** @format */

import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from 'src/constants';

export default function LanguageSelectorModal({ open, onClose, onLangChange }) {
  const { t, i18n } = useTranslation();

  const [lang, setLang] = useState(i18n.language || 'en');

  useEffect(() => {
    setLang(i18n.language || 'en');
  }, [i18n.language]);

  const handleClose = () => {
    onClose(false);
  };

  const LanguageButton = ({ data, isSelected, onLangChange }) => {
    return (
      <>
        <div
          onClick={() => {
            onLangChange(data?.value);
            setLang(data?.value);
          }}
          className={isSelected ? 'language-button language-button-selected' : 'language-button'}
        >
          <div className="language-description">
            <span className="language-title">{data?.market}</span>
            <span className="language-market">{data?.title}</span>
          </div>
          {isSelected && <CheckIcon />}
        </div>
      </>
    );
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        PaperProps={{
          style: {
            backgroundColor: '#fff'
          }
        }}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogActions>
          <IconButton onClick={handleClose}>
            <CloseIcon style={{ color: '#000' }} />
          </IconButton>
        </DialogActions>
        <DialogContent>
          <div className="language-selector-body">
            <Typography className="language-selector-title">{t('languageSelector.title')}</Typography>
            <Typography className="language-selector-sub-title">{t('languageSelector.subTitle')}</Typography>
            <Grid container spacing={2}>
              {LANGUAGES.sort((a, b) => a.market.localeCompare(b.market)).map((item, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <LanguageButton data={item} isSelected={Boolean(item.value === lang)} onLangChange={onLangChange} />
                </Grid>
              ))}
            </Grid>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
